import { render, staticRenderFns } from "./Kl.vue?vue&type=template&id=5b9a035a"
import script from "./Kl.vue?vue&type=script&lang=js"
export * from "./Kl.vue?vue&type=script&lang=js"
import style0 from "./Kl.vue?vue&type=style&index=0&id=5b9a035a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports